import { ContentBlockWrapperProps } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper.types';
import { ArticlePageBlockComponent } from '~types/BlockComponent.types';

export enum BgColor {
  Stroke = 'Stroke',
  White = 'White',
  Black = 'Black',
}

export type ContentBlockTextBgColorProps = ContentBlockWrapperProps & {
  component: ArticlePageBlockComponent.SectionTextBgColor;
  text: string;
  bgColor?: BgColor;
  titleMenu?: string;
};
